export default __webpack_public_path__ + "static/media/add_working_experience.5dfe01bb.svg";